/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconCart12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconCart12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M.5 1.5h2.14L3.015 3H11v.944c0 .535 0 .968-.03 1.321-.033.366-.1.687-.26.988a2.5 2.5 0 0 1-.66.795c-.267.21-.57.336-.925.434-.341.094-.767.173-1.293.27l-4.453.825L1.859 2.5.5 2.375V1.5ZM3.265 4l.856 3.423 3.507-.65c.553-.102.936-.173 1.23-.255.288-.08.45-.159.572-.255a1.5 1.5 0 0 0 .397-.476c.072-.138.12-.312.146-.609C9.998 4.888 10 4.52 10 4H3.265Z"
                fill="currentColor"
            />
            <path d="M9 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM2.5 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor" />
        </SVGContainer>
    );
});

const IconCart16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconCart16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M.667 2h2.854l.5 2h10.646v1.259c0 .712 0 1.29-.041 1.761-.043.488-.133.917-.345 1.318-.216.41-.516.771-.88 1.059-.357.281-.762.448-1.234.579-.455.126-1.023.231-1.724.36l-5.937 1.1L2.48 3.333.667 3.167V2Zm3.687 3.333 1.141 4.564 4.676-.866c.737-.136 1.248-.232 1.64-.34.384-.106.6-.212.763-.34a2 2 0 0 0 .528-.636c.097-.182.161-.415.196-.81.033-.388.036-.878.036-1.572h-8.98Z"
                fill="currentColor"
            />
            <path
                d="M12 13.333a1.333 1.333 0 1 1-2.666 0 1.333 1.333 0 0 1 2.666 0ZM3.334 14.667a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconCart24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconCart24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 3h4.28l.75 3H22v1.888c0 1.07 0 1.936-.062 2.642-.063.732-.198 1.375-.516 1.977a5 5 0 0 1-1.322 1.589c-.534.422-1.141.671-1.85.867-.683.19-1.535.348-2.586.542l-8.906 1.65L3.719 5 1 4.75V3Zm5.53 5 1.712 6.846 7.014-1.3c1.105-.204 1.871-.347 2.46-.51.575-.16.9-.317 1.144-.51a3 3 0 0 0 .793-.953c.145-.274.241-.623.293-1.217.05-.58.054-1.315.054-2.356H6.53Z"
                fill="currentColor"
            />
            <path d="M18 20a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM5 22a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" fill="currentColor" />
        </SVGContainer>
    );
});

export const IconCart = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconCart(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '12':
            return <IconCart12 {...iconProps} />;
        case '16':
            return <IconCart16 {...iconProps} />;
        case '24':
            return <IconCart24 {...iconProps} />;
        default:
            return <IconCart24 {...iconProps} />;
    }
});
